import React, { Component } from 'react';
import './App.css';
import Nav from './Components/Nav/Nav'
import Header from './Components/Header/Header'
import About from './Components/About/About';
import Portfolio from './Components/Portfolio/Portfolio'
import Resume from './Components/Resume/Resume';
import Contact from './Components/Contact/Contact';
import Detailcon from './Components/Detailcon/Detailcon';



class App extends Component {
  render() {
    return (
      <div className="App">
       <Nav />
       <Header />
       <About />
        <Portfolio />
        <Resume />
        <Contact />
        <Detailcon />
      </div>
    );
  }
}

export default App;
